import { DriverContractsListData } from "../../../../../../../common/services/driver/contracts/list/driver-contracts-list";
import BillingModel from "../../../../../../../common/types/billing-model";
import DriverContractListingBillingModel from "../../common/types/driver-contract-listing-billing-model";
import DriverContractListingByTaxiListingItem from "./types/driver-contract-listing-by-taxi-listing-item";

const createListingItemModel = (
  model: BillingModel,
): DriverContractListingBillingModel => {
  switch (model) {
    case BillingModel.AB:
      return DriverContractListingBillingModel.AB;
    case BillingModel.ABA:
      return DriverContractListingBillingModel.ABA;
    case BillingModel.OTHER:
      return DriverContractListingBillingModel.OTHER;
    case BillingModel.SABS:
      return DriverContractListingBillingModel.SABS;
  }
};

const createListingItem = (
  responseItem: DriverContractsListData,
): DriverContractListingByTaxiListingItem => {
  return {
    uuid: responseItem.contractId,
    billingModel: createListingItemModel(responseItem.model),
    distanceRate: responseItem.distanceRate,
    freeStoppingPeriodMinutes: responseItem.haltingTimeAfterMinutes,
    stoppingRate: responseItem.haltingTimeRate,
    periodOfValidity: {
      from: new Date(responseItem.validSince),
      to: new Date(responseItem.validTo),
    },
    isActive: responseItem.active,
  };
};

const createListingItems = (
  responseData: DriverContractsListData[],
): DriverContractListingByTaxiListingItem[] => {
  return responseData.map(createListingItem);
};

const driverContractListingByTaxiFactory = {
  createListingItems,
};

export default driverContractListingByTaxiFactory;
